<div class="section-pd section-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>彈性訂價，量身打造</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>
                        Trinka 提供依使用者數量或實際用量計費的彈性方案，滿足您企業的多元需求。可即時更換使用者或設定使用限制，無需額外費用。我們也可協助您量身打造合約，並提供採購單或發票的一次性付款選項，讓流程更加簡便無憂。
                    </p>
                    <div class="btn-group justify-content-center mt-4">
                        <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button">索取報價 </button>
                        <a href="https://calendly.com/trinkaai/meet" target="_blank" id="autoEditGetStart" class="outline-btn">預約產品演示</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
